const process = () => import('./process.vue');
const info = () => import('./info/index.vue');
const notifications = () => import('./notifications/index.vue');
const password = () => import('./password/index.vue');

export default [
  {
    path: '',
    component: process,
    children: [
      {
        path: 'info',
        component: info,
        name: 'profile-info',
        meta: {
          title: 'pageTitles.routes.profile.root'
        }
      },
      {
        path: 'notifications',
        component: notifications,
        name: 'profile-notifications',
        meta: {
          title: 'pageTitles.routes.profile.notifications'
        }
      },
      {
        path: 'password',
        component: password,
        name: 'profile-password',
        meta: {
          title: 'pageTitles.routes.profile.password'
        }
      },
      {
        path: '*',
        redirect: { name: 'profile-info' }
      },
      {
        path: '',
        redirect: { name: 'profile-info' }
      }
    ]
  }
];
